import { render, staticRenderFns } from "./EpisodeListCardHorizontal.vue?vue&type=template&id=238d6b97&scoped=true&"
import script from "./EpisodeListCardHorizontal.vue?vue&type=script&lang=js&"
export * from "./EpisodeListCardHorizontal.vue?vue&type=script&lang=js&"
import style0 from "./EpisodeListCardHorizontal.vue?vue&type=style&index=0&id=238d6b97&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238d6b97",
  null
  
)

export default component.exports